// validationRules.js
// Common reusable validation rules
import moment from 'moment';
import Utils from './utils';

export default {
  required(message) {
    return {
      validate(value) {
        return value !== null && value !== undefined &&
          value.toString().trim() !== '';
      },
      message
    };
  },

  number(message) {
    return {
      validate(value) {
        return !isNaN(value);
      },
      message
    };
  },

  positiveNumber(message) {
    return {
      validate(value) {
        return Number(value) > 0;
      },
      message
    };
  },

  date(format, message) {
    return {
      validate(value) {
        return value === null || value === undefined || value.toString().trim() === '' || Utils.isValidDate(value, format, true);
      },
      message
    };
  },

  length(length, message) {
    return {
      validate(value) {
        if (value !== null && value !== undefined) {
          return value.toString().trim().length === Number(length);
        }
        return false;
      },
      message
    };
  },

  min(minValue, message) {
    return {
      validate(value) {
        return Number(value) >= Number(minValue);
      },
      message
    };
  },

  max(maxValue, message) {
    return {
      validate(value) {
        return Number(value) <= Number(maxValue);
      },
      message
    };
  },

  minDate(minValue, format, message) {
    return {
      validate(value) {
        if (Utils.isValidDate(value, format)) {
          return new Date(value) >= new Date(minValue);
        }
        return false;
      },
      message
    };
  },

  maxDate(maxValue, format, message) {
    return {
      validate(value) {
        if (Utils.isValidDate(value, format)) {
          return new Date(value) <= new Date(maxValue);
        }
        return false;
      },
      message
    };
  },

  greaterThan(compare, message) {
    return {
      validate(value) {
        return Number(value) > Number(compare);
      },
      message
    };
  },

  lessThan(compare, message) {
    return {
      validate(value) {
        return Number(value) < Number(compare);
      },
      message
    };
  },

  greaterThanDate(compare, format, message) {
    return {
      validate(value) {
        if (Utils.isValidDate(value, format)) {
          return moment(value, format) > moment(compare);
        }
        return false;
      },
      message
    };
  },

  lessThanDate(compare, format, message) {
    return {
      validate(value) {
        if (Utils.isValidDate(value, format)) {
          return moment(value, format) < moment(compare);
        }
        return false;
      },
      message
    };
  },

  notEqual(compare, message) {
    return {
      validate(value) {
        return compare !== value;
      },
      message
    };
  },

  custom(fn, message) {
    return {
      validate(value) {
        return fn(value);
      },
      message
    };
  }
};